import { locales } from '../config';

export function convert(base, rates, amount, from, to) {
    if (rates[from]) return ((amount / rates[from]) * rates[to || base]);
    return 0;
}

export function showCurrencySymbol(currency) {
    let defaultValue = 0, convertCurrency, symbol;
    convertCurrency = currency ? currency : 'USD';
    symbol = defaultValue.toLocaleString(locales[0], { style: 'currency', currency: convertCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\d+([,.]\d+)?/g, "") || null;
    symbol = (symbol && symbol.toString().trim() == currency) ? '' : (symbol + ' ');
    return symbol;
}

export function getCurrencySymbol(currency) {
    let defaultValue = 0, convertCurrency, symbol;
    convertCurrency = currency ? currency : 'USD';
    symbol = defaultValue.toLocaleString(locales[0], { style: 'currency', currency: convertCurrency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).replace(/\d+([,.]\d+)?/g, "") || null;
    return symbol;
}


export function getFixedValue(value) {
    if (!value) return value;
    return Number((Math.round(value * 100) / 100).toFixed(2));
}